import { partial } from '../../../util/translation/translation';
import { TAKEOVER_DELAY_MAX } from '../takeoverUtils';

const p = partial('validateErrors');
const validateGroupForm = (values) => {
  const errors = {};
  if (!values.title) {
    errors.title = p('titleFieldEmpty');
  }
  // Optional group colours: empty, or a full hex colour
  [
    'backgroundColor',
    'textColor',
    'accentColor',
    'descriptionBackgroundColor',
    'descriptionTextColor',
  ].forEach((name) => {
    if (values[name] && !/^#([0-9a-f]{6}|[0-9a-f]{8})$/i.test(values[name])) {
      errors[name] = p('colorInvalid');
    }
  });
  // A takeover's wait after Home has loaded: empty, or whole seconds
  const delay = `${values.takeoverDelaySeconds ?? ''}`.trim();
  if (
    values.format === 'TAKEOVER' &&
    delay &&
    (!/^\d+$/.test(delay) || Number(delay) > TAKEOVER_DELAY_MAX)
  ) {
    errors.takeoverDelaySeconds = p('takeoverDelayInvalid', {
      max: TAKEOVER_DELAY_MAX,
    });
  }
  return errors;
};

export default validateGroupForm;
